import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  doCreateSubscription,
  doDisplaySubscriptionGreeting,
  setPaymentInfo
} from '../actions/subscriptions';

import CreateSubscription from '../components/products/CreateSubscription';
import { withNavigation } from '../actions/navigation';

/**
 * Create subscription form, exposing handlers to create (trial) subscriptions
 * or purchase a subscription
 */

const makeCreateSubscription = (dispatch, {isPurchase, navigateToSubscription}) => 
  ({ account, product, plan, licencesCount }) => 
    // creates a subscription
    dispatch(doCreateSubscription(account.id, product.id, plan.id, licencesCount))
      .then( ({subscription}) => {
        if( subscription ) {
          // then navigate to subscription page 
          navigateToSubscription(subscription.id);
          // if purchasing, move to payment info page
          if( isPurchase ) {
            return dispatch(setPaymentInfo(subscription));
          } else {
            dispatch( doDisplaySubscriptionGreeting(subscription.id) );
          }
        }
      });

const mapDispatchToProps = (dispatch, {navigateToSubscription}) => ({
  handleSubscribe: makeCreateSubscription(dispatch, {
    isPurchase: false,
    navigateToSubscription,
  }),

  handlePurchase: makeCreateSubscription(dispatch, {
    isPurchase: true,
    navigateToSubscription,
  }),
});


const mapStateToProps = state => {
  return {
    isCreatingSubscription: state.creatingSubscription,
    planTargetPeriodicity: state.planTargetPeriodicity
  };
}

export default compose(
  withNavigation,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CreateSubscription)


// WEBPACK FOOTER //
// ./src/containers/CreateSubscription.js